// extracted by mini-css-extract-plugin
module.exports = {"word":"word--ss414"};